import React, { useCallback, useMemo } from 'react';
import { ServiceRequestData } from '@services/types/Relationship/MyCalls/types';
import useSwr from '@hooks/useSwr';
import { List } from 'antd';
import moment from 'moment';
import CustomTag from '@components/CustomTag';
import MessagesList, { MessageData } from './MessagesList';
import MessagesShipping from './MessagesShipping';
import MessagesHeader from './MessagesHeader';
import { MessagesActionNames } from './MessagesHeader/MessagesActions';
import * as S from './style';

interface RequestMessagesProps {
  request?: ServiceRequestData;
  onMutateRequest?: (action: MessagesActionNames, requestId: number) => void;
}

const RequestMessages = ({
  request,
  onMutateRequest,
}: RequestMessagesProps) => {
  const { data, mutate } = useSwr<
    | {
        worklogViewList: MessageData[];
      }
    | undefined
  >(request ? 'service-proxy/service/request/findWorklog' : null, {
    params: { assetId: request?.asset?.assetNumber },
    method: 'post',
    data: {
      objectId: request?.id,
      objectTypeName: 'SERVICE_REQUEST',
    },
  });

  const groupByDay = useCallback(
    (list: MessageData[] | undefined) =>
      list
        ?.sort(
          (a, b) => moment(a.createAt).valueOf() - moment(b.createAt).valueOf(),
        )
        .reduce<Record<string, MessageData[]>>((acc, item) => {
          const day = moment(item.createAt).format('YYYY-MM-DD');
          if (!acc[day]) {
            acc[day] = [];
          }
          acc[day].push(item);
          return acc;
        }, {}),
    [],
  );

  const messagesData = useMemo(
    (): [string, MessageData[]][] | undefined =>
      Object.entries(groupByDay(data?.worklogViewList) ?? {}),
    [data?.worklogViewList, groupByDay],
  );

  return (
    <S.RequestMessagesCard loading={!data}>
      <MessagesHeader request={request} onMutateRequest={onMutateRequest} />
      <List
        dataSource={messagesData}
        className="request-messages-main-list"
        renderItem={([groupDay, messages], index) => (
          <List.Item className="list-items-group">
            <CustomTag className={index === 0 ? 'first-group-day-tag' : ''}>
              {moment(groupDay).format('DD/MM/YYYY')}
            </CustomTag>
            <MessagesList messages={messages} />
          </List.Item>
        )}
      />
      {request?.treatedStatus?.value && (
        <MessagesShipping request={request} mutateNewMessage={() => mutate()} />
      )}
    </S.RequestMessagesCard>
  );
};

export default RequestMessages;
